"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Yup = tslib_1.__importStar(require("yup"));
const testIfJson_1 = require("./testIfJson");
exports.RESPONSE_TYPES = [
    { label: 'JSON', value: 'json' },
    { label: 'XML', value: 'xml' },
];
exports.DEFAULT_RESPONSE_TYPE_OPTION = exports.RESPONSE_TYPES[0];
exports.CONTENT_FEED_YUP_SCHEMA = Yup.object().shape({
    contentMapping: Yup.object()
        .default(null)
        .nullable(true)
        .notRequired(),
    headers: Yup.string()
        .default(null)
        .nullable(true)
        .test('headers', 'Invalid headers JSON', testIfJson_1.testIfJson),
    name: Yup.string().required('Required'),
    responseType: Yup.string().required('Required'),
    url: Yup.string().url(),
    useHeadersFromContentFeed: Yup.object()
        .default(null)
        .nullable(true)
        .notRequired(),
});
//# sourceMappingURL=constants.js.map